import { useState, useEffect } from "react";
import VehiculeForm from "../components/VehiculeForm";
import VehiculeList from "../components/VehiculeList";
import Checklist from "../components/CheckListe";

export default function CheckPage() {

  return (
    <div className=" w-[100%] h-[100%]  flex flex-col items-center mt-10 justify-center  absolute p-9">

     <Checklist/>
    </div>
  );
}
